import { Fragment, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHeader, Section, Badge, Select } from "@/components/Shared";

const ENTITY_TONES = { partner: "muted", merchant: "muted", program: "accent", volume: "default", period_close: "positive" };
const ACTION_TONES = { CREATE: "positive", UPDATE: "accent", DELETE: "warning", IMPORT: "accent", CLOSE: "positive", REOPEN: "warning" };

export default function AuditLog() {
  const [logs, setLogs] = useState([]);
  const [filter, setFilter] = useState("");
  const [expanded, setExpanded] = useState(null);

  const load = async () => {
    const params = filter ? `?entity=${filter}` : "";
    const { data } = await api.get(`/audit-logs${params}`);
    setLogs(data);
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [filter]);

  const fmtTs = (iso) => {
    try { const d = new Date(iso); return d.toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" }); } catch { return iso; }
  };

  return (
    <div data-testid="audit-page">
      <PageHeader
        title="Audit Trail"
        actions={<div className="w-44"><Select placeholder="All entities" testid="audit-filter" options={["partner", "merchant", "program", "volume", "period_close"]} value={filter} onChange={setFilter} /></div>}
      />
      <div className="p-4 sm:p-10">
        <Section title={`${logs.length} entries`} testid="audit-section">
          <div className="overflow-x-auto"><table className="table-data w-full">
            <thead><tr><th>Timestamp</th><th>Action</th><th>Entity</th><th>ID</th><th>Summary</th><th></th></tr></thead>
            <tbody>
              {logs.map((l) => (
                <Fragment key={l.id}>
                  <tr data-testid={`audit-row-${l.id}`} className="cursor-pointer" onClick={() => setExpanded(expanded === l.id ? null : l.id)}>
                    <td className="num text-[12px]">{fmtTs(l.ts)}</td>
                    <td><Badge tone={ACTION_TONES[l.action] || "default"}>{l.action}</Badge></td>
                    <td><Badge tone={ENTITY_TONES[l.entity] || "default"}>{l.entity}</Badge></td>
                    <td className="num text-[12px]">{l.entity_id}</td>
                    <td>{l.summary}</td>
                    <td className="text-right text-[var(--muted)] text-[11px]">{expanded === l.id ? "▲" : "▼"}</td>
                  </tr>
                  {expanded === l.id && (
                    <tr><td colSpan={6} className="bg-[var(--surface-2)]">
                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 px-4 py-3">
                        <div><div className="text-[10px] uppercase tracking-wider text-[var(--muted)] font-semibold mb-1">Before</div>
                          <pre className="text-[11px] bg-white border border-[var(--line)] p-2 max-h-60 overflow-auto whitespace-pre-wrap">{l.before ? JSON.stringify(l.before, null, 2) : "—"}</pre></div>
                        <div><div className="text-[10px] uppercase tracking-wider text-[var(--muted)] font-semibold mb-1">After</div>
                          <pre className="text-[11px] bg-white border border-[var(--line)] p-2 max-h-60 overflow-auto whitespace-pre-wrap">{l.after ? JSON.stringify(l.after, null, 2) : "—"}</pre></div>
                      </div>
                    </td></tr>
                  )}
                </Fragment>
              ))}
            </tbody>
          </table></div>
        </Section>
      </div>
    </div>
  );
}
